<template>
  <div class="pdf">
    <!-- 阅读方式按钮组 -->
    <div class="reading-mode-buttons">
      <button :class="['mode-btn', { active: currentMode === 'original' }]" @click="changeReadingMode('original')">阅读原文</button>
      <button :class="['mode-btn', { active: currentMode === 'comparison' }]" @click="changeReadingMode('comparison')">对照翻译</button>
      <button :class="['mode-btn', { active: currentMode === 'translated' }]" @click="changeReadingMode('translated')">阅读翻译</button>
      <select class="mode-select" v-model="modeid" @change="changeLanguage(modeid)">
        <option v-for="mode in modeList" :key="mode.key" :value="mode.key">
          {{ mode.value }}
        </option>
      </select>
    </div>

    <!-- :src="`/static/viewer/web/viewer.html?file=${tranPdfUrl}&type=nonote`" -->
    <iframe v-if="tranPdfUrl" id="tranIframe" :src="`/static/viewer/web/viewer.html?file=${encodeURIComponent(tranPdfUrl)}`" frameborder="0" :style="{ width: getTranslatedWidth, height: 'calc(100vh - 80px)' }"></iframe>

    <!-- :src="`/static/viewer/web/viewer.html?file=${src}`" -->
    <iframe v-if="pdfUrl" id="orgIframe" :src="`/static/viewer/web/viewer.html?file=${encodeURIComponent(pdfUrl)}`" frameborder="0" :style="{ width: getOriginalWidth, height: 'calc(100vh - 80px)' }"></iframe>
  </div>
</template>
<script>
import baseUrl from "@/api/baseurl.js";
export default {
  data() {
    return {
      baseUrl: baseUrl.baseUrl,
      src: null,
      pdfUrl: "",
      loading: false,
      scrollT: 0,
      scrollO: 0,
      scrollType: null,
      tranIsBind: false,
      orgIsbingd: false,
      scaleUpdating: null, // 用于跟踪缩放同步的来源，防止循环触发
      fileMd5: "",
      getfile: false,
      tranPdfUrl: "",
      currentMode: "original", // 默认阅读原文模式
      getOriginalWidth: "100%",
      getTranslatedWidth: "0%",
      isBindEvent: false,
      modeList: [],
      modeid: "zh",
    };
  },
  activated() {
    // this.getPdfCode();
  },
  created() {
    if (this.$route.query.jyx_token) {
      localStorage.setItem("jyx_token", this.$route.query.jyx_token);
      // 清除 url 上的 token 避免泄露（可选）
      const newQuery = { ...this.$route.query };
      delete newQuery.jyx_token;
      this.$router.replace({ query: newQuery }).catch(() => {});
    }

    const query = this.$route.query;
    this.openAlexId = null;
    this.pdfType = null;
    this.sid = null;
    if (query.openAlexId) {
      this.openAlexId = query.openAlexId;
    }
    if (query.pdfType) {
      this.pdfType = query.pdfType;
    }
    if (query.sid) {
      this.sid = query.sid;
    }
    if (query.fileMd5) {
      this.fileMd5 = query.fileMd5;
    }

    // 如果只有fileMd5有值，则默认currentMode为translated
    if (this.fileMd5 && !this.openAlexId && !this.pdfType && !this.sid) {
      this.currentMode = "translated";
      this.getOriginalWidth = this.getOriginalWidthFn;
      this.getTranslatedWidth = this.getTranslatedWidthFn;
    }
    this.getModeList();
    const _this = this;
    window.addEventListener("message", function (e) {
      console.log("message", e.data.data);
      if (e.data.data == "tran" && !_this.tranIsBind) {
        _this.tranIsBind = true;
        _this.scrollType = null;
      } else if (e.data.data == "org" && !_this.orgIsbingd) {
        _this.orgIsbingd = true;
        _this.scrollType = null;
      }

      if (_this.orgIsbingd && _this.tranIsBind && !_this.isBindEvent) {
        _this.isBindEvent = true;
        _this.orgSyncScroll();
        _this.tranSyncScroll();
      }
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.getPdfCode();
      this.getFilePdfUrl();
    });
    // this.syncIframeScroll();
  },
  computed: {
    // 根据当前模式返回原文iframe的宽度
    getOriginalWidthFn() {
      switch (this.currentMode) {
        case "original":
          return "100%";
        case "comparison":
          return "49%";
        case "translated":
          return "0%";
        default:
          return "100%";
      }
    },
    // 根据当前模式返回译文iframe的宽度
    getTranslatedWidthFn() {
      switch (this.currentMode) {
        case "original":
          return "0%";
        case "comparison":
          return "49%";
        case "translated":
          return "100%";
        default:
          return "0%";
      }
    },
  },
  methods: {
    //切换阅读语言
    changeLanguage(lang) {
      this.modeid = lang;
      // 没有翻译PDF，调用getFilePdfUrl方法获取
      this.getTranslatUrl(this.currentMode);
    },
    // 切换阅读模式
    changeReadingMode(mode) {
      // 如果是切换到对照翻译或阅读翻译模式
      if (mode === "comparison" || mode === "translated") {
        // 检查是否已经有翻译PDF的URL
        if (this.tranPdfUrl) {
          // 已有翻译PDF，直接切换模式
          this.currentMode = mode;
          console.log("切换阅读模式为:", mode);
          this.getOriginalWidth = this.getOriginalWidthFn;
          this.getTranslatedWidth = this.getTranslatedWidthFn;
          if (mode == "comparison") {
            this.tranSyncScroll();
            this.orgSyncScroll();
          }
        } else {
          // 没有翻译PDF，调用getFilePdfUrl方法获取
          this.getTranslatUrl(mode);
        }
      } else {
        // 阅读原文模式，直接切换
        this.currentMode = mode;
        console.log("切换阅读模式为:", mode);
        this.getOriginalWidth = this.getOriginalWidthFn;
        this.getTranslatedWidth = this.getTranslatedWidthFn;
      }
    },

    getPdfCode: function () {
      this.loading = true;
      this.prohibit();
      // 数据文件流 转成 pdf
      if (this.openAlexId) {
        this.$http({
          url: `api/v1/reception/journalpaper/pdf/url?openAlexId=${this.openAlexId}&pdfType=${this.pdfType}`,
          method: "GET",
        }).then(res => {
          this.pdfUrl = res.data;
          console.log(this.pdfUrl);
        });
      }
      if (this.sid) {
        this.pdfUrl = `${this.baseUrl}api/v1/user/literature/load?sid=${this.sid}`;
      }
    },
    getFilePdfUrl(mode = "original") {
      if (!this.fileMd5) {
        return;
      }
      this.$http({
        url: "asp/api/v1/ai-service/file-translate/getFileInfoByFileMd5?fileMd5=" + this.fileMd5 + "&transMode=" + this.modeid,
        methods: "get",
      }).then(res => {
        if (res && res.data && res.code === 200) {
          this.tranPdfUrl = res.data.fileOnlyTranslationUrl + "&type=nonote";
          if (!this.pdfUrl) {
            this.pdfUrl = this.fileUrl;
          }
          this.fileComparisonTranslationUrl = res.data.fileComparisonTranslationUrl;
          this.currentMode = mode;
          console.log("切换阅读模式为:", mode);
          this.getOriginalWidth = this.getOriginalWidthFn;
          this.getTranslatedWidth = this.getTranslatedWidthFn;
          this.getfile = true;
          if (mode == "comparison") {
            this.syncIframeScroll();
          }
        } else {
          this.$message.warning("当前文章暂无翻译，已申请进行翻译，稍后可在文献服务平台的文献翻译结果中进行进度查看。");
        }
      });
    },
    //同步iframe的滚动条位置
    tranSyncScroll() {
      let pdfFrame = document.getElementById("tranIframe").contentWindow; //左
      let pdfFrameTran = document.getElementById("orgIframe").contentWindow; //右

      // 添加延迟检查，等待iframe完全加载完成后设置缩放同步
      const checkAndSetupScaleSyncFromTran = () => {
        console.log("检查左侧PDFViewerApplication状态:", pdfFrame.PDFViewerApplication);

        if (pdfFrame.PDFViewerApplication && pdfFrame.PDFViewerApplication.eventBus) {
          console.log("左侧PDFViewerApplication已就绪，创建scalechanging监听");
          // 设置从左侧到右侧的缩放同步监听
          pdfFrame.PDFViewerApplication.eventBus.on("scalechanging", evt => {
            try {
              // 检查是否是由右侧同步触发的缩放变化，如果是则跳过，防止循环触发
              if (this.scaleUpdating === "org") {
                console.log("检测到由右侧同步触发的缩放变化，跳过同步");
                return;
              }

              console.log("从左侧接收到scalechanging事件:", evt);
              // 检查右侧orgIframe中的PDFViewerApplication是否可用
              if (pdfFrameTran && pdfFrameTran.PDFViewerApplication && pdfFrameTran.PDFViewerApplication.pdfViewer) {
                // 设置标记，表示正在从左侧同步到右侧
                this.scaleUpdating = "tran";

                // 如果有预设值（如"page-width"等），则使用预设值
                // 否则使用具体的缩放数值
                if (evt.presetValue) {
                  pdfFrameTran.PDFViewerApplication.pdfViewer.currentScaleValue = evt.presetValue;
                } else {
                  pdfFrameTran.PDFViewerApplication.pdfViewer.currentScale = evt.scale;
                }

                console.log("从左侧同步缩放变化到右侧:", evt.scale, evt.presetValue);

                // 使用setTimeout在下一个事件循环中重置标记，确保同步操作完成
                setTimeout(() => {
                  this.scaleUpdating = null;
                }, 0);
              } else {
                console.warn("右侧orgIframe中的PDFViewerApplication尚未就绪");
              }
            } catch (error) {
              console.error("从左侧同步缩放时发生错误:", error);
              // 发生错误时也要重置标记
              this.scaleUpdating = null;
            }
          });

          pdfFrame.PDFViewerApplication.eventBus.on("documentloaded", evt => {
            try {
              console.log("接收到tranIframe的documentloaded事件:", evt);
              // 检查tranIframe中的PDFViewerApplication是否可用
              if (pdfFrameTran && pdfFrameTran.PDFViewerApplication && pdfFrameTran.PDFViewerApplication.pdfViewer) {
                pdfFrame.document.getElementById("viewerContainer").addEventListener("scroll", e => {
                  if (this.scrollType == null || this.scrollType == "tran") {
                    this.scrollType = "tran";
                  } else {
                    return;
                  }
                  let viewerContainer = pdfFrame.document.getElementById("viewerContainer");
                  let scrollT = viewerContainer.scrollTop;
                  let scrollL = viewerContainer.scrollLeft;
                  let rollT = scrollT - this.scrollT;
                  let rollL = scrollL - this.scrollL;
                  this.scrollT = scrollT;
                  this.scrollL = scrollL;
                  // console.log('tranIframe纵向滚动:', e.target.scrollTop, rollT);
                  // console.log('tranIframe横向滚动:', e.target.scrollLeft, rollL);

                  // 同步纵向滚动
                  pdfFrameTran.document.getElementById("viewerContainer").scrollTop = pdfFrameTran.document.getElementById("viewerContainer").scrollTop + rollT;
                  // 同步横向滚动
                  pdfFrameTran.document.getElementById("viewerContainer").scrollLeft = pdfFrameTran.document.getElementById("viewerContainer").scrollLeft + rollL;

                  this.scrollType = null;
                });
              } else {
                console.warn("右侧orgIframe中的PDFViewerApplication尚未就绪");
              }
            } catch (error) {
              console.error("PDF加载时发生错误:", error);
            }
          });
        } else {
          // 如果PDFViewerApplication尚未就绪，延迟重试
          console.log("左侧PDFViewerApplication尚未就绪，将在1000ms后重试");
          setTimeout(checkAndSetupScaleSyncFromTran, 500);
        }
      };

      // 立即执行第一次检查
      checkAndSetupScaleSyncFromTran();
      console.log("tranIframe滚动事件监听已添加");

      pdfFrame.document.getElementById("viewerContainer").addEventListener("scroll", e => {
        if (this.scrollType == null || this.scrollType == "tran") {
          this.scrollType = "tran";
        } else {
          return;
        }
        let viewerContainer = pdfFrame.document.getElementById("viewerContainer");
        let scrollT = viewerContainer.scrollTop;
        let scrollL = viewerContainer.scrollLeft;
        let rollT = scrollT - this.scrollT;
        let rollL = scrollL - this.scrollL;
        this.scrollT = scrollT;
        this.scrollL = scrollL;
        // console.log('tranIframe纵向滚动:', e.target.scrollTop, rollT);
        // console.log('tranIframe横向滚动:', e.target.scrollLeft, rollL);

        // 同步纵向滚动
        pdfFrameTran.document.getElementById("viewerContainer").scrollTop = pdfFrameTran.document.getElementById("viewerContainer").scrollTop + rollT;
        // 同步横向滚动
        pdfFrameTran.document.getElementById("viewerContainer").scrollLeft = pdfFrameTran.document.getElementById("viewerContainer").scrollLeft + rollL;

        this.scrollType = null;
      });
    },
    //同步iframe的滚动条位置（包含横向和纵向）
    orgSyncScroll() {
      let pdfFrame = document.getElementById("tranIframe").contentWindow; //左
      let pdfFrameTran = document.getElementById("orgIframe").contentWindow; //右

      // 添加延迟检查，等待iframe完全加载完成
      const checkAndSetupScaleSync = () => {
        console.log("检查PDFViewerApplication状态:", pdfFrameTran.PDFViewerApplication);

        if (pdfFrameTran.PDFViewerApplication && pdfFrameTran.PDFViewerApplication.eventBus) {
          console.log("PDFViewerApplication已就绪，创建scalechanging监听");
          // 设置缩放同步监听
          pdfFrameTran.PDFViewerApplication.eventBus.on("scalechanging", evt => {
            try {
              // 检查是否是由左侧同步触发的缩放变化，如果是则跳过，防止循环触发
              if (this.scaleUpdating === "tran") {
                console.log("检测到由左侧同步触发的缩放变化，跳过同步");
                return;
              }

              console.log("接收到scalechanging事件:", evt);
              // 检查tranIframe中的PDFViewerApplication是否可用
              if (pdfFrame && pdfFrame.PDFViewerApplication && pdfFrame.PDFViewerApplication.pdfViewer) {
                // 设置标记，表示正在从右侧同步到左侧
                this.scaleUpdating = "org";

                // 如果有预设值（如"page-width"等），则使用预设值
                // 否则使用具体的缩放数值
                if (evt.presetValue) {
                  pdfFrame.PDFViewerApplication.pdfViewer.currentScaleValue = evt.presetValue;
                } else {
                  pdfFrame.PDFViewerApplication.pdfViewer.currentScale = evt.scale;
                }

                console.log("同步缩放变化:", evt.scale, evt.presetValue);

                // 使用setTimeout在下一个事件循环中重置标记，确保同步操作完成
                setTimeout(() => {
                  this.scaleUpdating = null;
                }, 0);
              } else {
                console.warn("tranIframe中的PDFViewerApplication尚未就绪");
              }
            } catch (error) {
              console.error("同步缩放时发生错误:", error);
              // 发生错误时也要重置标记
              this.scaleUpdating = null;
            }
          });

          pdfFrameTran.PDFViewerApplication.eventBus.on("documentloaded", evt => {
            try {
              console.log("接收到orgIframe的documentloaded事件:", evt);
              // 检查tranIframe中的PDFViewerApplication是否可用
              if (pdfFrame && pdfFrame.PDFViewerApplication && pdfFrame.PDFViewerApplication.pdfViewer) {
                pdfFrameTran.document.getElementById("viewerContainer").addEventListener("scroll", e => {
                  if (this.scrollType == null || this.scrollType == "org") {
                    this.scrollType = "org";
                  } else {
                    return;
                  }
                  let viewerContainer = pdfFrameTran.document.getElementById("viewerContainer");
                  let scrollT = viewerContainer.scrollTop;
                  let scrollL = viewerContainer.scrollLeft;
                  let rollT = scrollT - this.scrollT;
                  let rollL = scrollL - this.scrollL;
                  this.scrollT = scrollT;
                  this.scrollL = scrollL;
                  // console.log('orgIframe纵向滚动:', e.target.scrollTop, rollT);
                  // console.log('orgIframe横向滚动:', e.target.scrollLeft, rollL);

                  // 同步纵向滚动
                  pdfFrame.document.getElementById("viewerContainer").scrollTop = pdfFrame.document.getElementById("viewerContainer").scrollTop + rollT;
                  // 同步横向滚动
                  pdfFrame.document.getElementById("viewerContainer").scrollLeft = pdfFrame.document.getElementById("viewerContainer").scrollLeft + rollL;

                  this.scrollType = null;
                });
              } else {
                console.warn("tranIframe中的PDFViewerApplication尚未就绪");
              }
            } catch (error) {
              console.error("PDF加载时发生错误:", error);
            }
          });
        } else {
          // 如果PDFViewerApplication尚未就绪，延迟重试
          console.log("PDFViewerApplication尚未就绪，将在1000ms后重试");
          setTimeout(checkAndSetupScaleSync, 1000);
        }
      };

      // 立即执行第一次检查
      checkAndSetupScaleSync();
      console.log("orgIframe滚动事件监听已添加");

      pdfFrameTran.document.getElementById("viewerContainer").addEventListener("scroll", e => {
        if (this.scrollType == null || this.scrollType == "org") {
          this.scrollType = "org";
        } else {
          return;
        }
        let viewerContainer = pdfFrameTran.document.getElementById("viewerContainer");
        let scrollT = viewerContainer.scrollTop;
        let scrollL = viewerContainer.scrollLeft;
        let rollT = scrollT - this.scrollT;
        let rollL = scrollL - this.scrollL;
        this.scrollT = scrollT;
        this.scrollL = scrollL;
        // console.log('orgIframe纵向滚动:', e.target.scrollTop, rollT);
        // console.log('orgIframe横向滚动:', e.target.scrollLeft, rollL);

        // 同步纵向滚动
        pdfFrame.document.getElementById("viewerContainer").scrollTop = pdfFrame.document.getElementById("viewerContainer").scrollTop + rollT;
        // 同步横向滚动
        pdfFrame.document.getElementById("viewerContainer").scrollLeft = pdfFrame.document.getElementById("viewerContainer").scrollLeft + rollL;

        this.scrollType = null;
      });
    },
    syncIframeScroll() {},
    getTranslatUrl(mode) {
      let formData = new FormData();
      formData.append("paperSid", this.sid);
      formData.append("transMode", this.modeid);
      this.$http({
        url: `asp/api/v1/user/literature/createPaperFileTranslate`,
        method: "POST",
        data: formData,
      }).then(res => {
        console.log(res);
        if (res.code == 200) {
          if (res.data) {
            this.fileMd5 = res.data;
            this.getFilePdfUrl(mode);
          } else {
            this.$message.warning("当前文章暂无翻译，已申请进行翻译，稍后可在文献服务平台的文献翻译结果中进行进度查看。");
          }
        }
      });
    },
    // 禁用鼠标右击、F12 来禁止打印和打开调试工具
    prohibit() {
      document.oncontextmenu = function (ev) {
        return false; //屏蔽右键菜单
      };
      document.onkeydown = function (e) {
        if (e.ctrlKey && (e.keyCode === 65 || e.keyCode === 67 || e.keyCode === 73 || e.keyCode === 74 || e.keyCode === 80 || e.keyCode === 83 || e.keyCode === 85 || e.keyCode === 86 || e.keyCode === 117)) {
          return false;
        }
        if (e.keyCode === 18 || e.keyCode === 123) {
          return false;
        }
      };
    },
    //获取翻译状态
    getModeList() {
      this.$http({
        url: `asp/api/v1/ai-service/file-translate/getTransModeList`,
        method: "get",
      }).then(res => {
        if (res.code == 200) {
          if (res.data) {
            this.modeList = res.data;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.reading-mode-buttons {
  display: flex;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.mode-btn {
  padding: 8px 16px;
  border: 1px solid #dcdfe6;
  background-color: #ffffff;
  color: #606266;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
  outline: none;
}

.mode-btn:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.mode-btn:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.mode-btn:not(:last-child) {
  border-right: none;
}

.mode-btn:hover {
  color: #409eff;
  border-color: #c6e2ff;
}

.mode-btn.active {
  color: #ffffff;
  background-color: #409eff;
  border-color: #409eff;
}
.mode-select {
  padding: 8px 16px;
  border: 1px solid #dcdfe6;
  background-color: #ffffff;
  color: #606266;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
  outline: none;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.mode-select:hover {
  color: #409eff;
  border-color: #c6e2ff;
}

.mode-select:focus {
  color: #409eff;
  border-color: #c6e2ff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}
</style>
